// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const requiredDetails = [
	"Client name",
	"Property address",
	"Transaction type (buyer or seller)",
	"Closing date",
	"Sale price",
	"Gross commission, if available",
	"Any other relevant transaction details",
];

function Duplicate() {
	return (
		<DashboardLayout>
			<DashboardNavbar />
			<Grid container direction="column" height="80vh">
				<Grid item xs>
					<MDBox>
						<Grid container spacing={3} justifyContent="center">
							<Grid item xs={12} lg={8}>
								<MDTypography align="left" variant="h2" pt={5} pb={4} color="soliddark">
									<b>Report Multiple Transaction</b>
								</MDTypography>
								<MDBox bgColor="white" p={3} sx={{ borderRadius: "12px" }}>
									<MDTypography variant="body1" color="soliddark" mb={3}>
										When a client completes a transaction on an additional property, a referral fee is owed on{" "}
										<b>all transactions that occur within two years of the agent accepting the original referral</b>
										. To report the additional/duplicate transaction, please email{" "}
										<a
											href="mailto:escrow@myagentfinder.com"
											style={{ color: "#1A73E8", textDecoration: "underline" }}
										>
											escrow@myagentfinder.com
										</a>{" "}
										with the following details:
									</MDTypography>
									<MDBox component="ul" pl={3} mb={0} sx={{ listStyleType: "disc" }}>
										{requiredDetails.map((detail) => (
											<MDTypography
												key={detail}
												component="li"
												variant="body1"
												color="soliddark"
												mb={1}
											>
												{detail}
											</MDTypography>
										))}
									</MDBox>
								</MDBox>
							</Grid>
						</Grid>
					</MDBox>
				</Grid>
				<Grid item style={{ alignSelf: "flex-start" }}>
					<Footer />
				</Grid>
			</Grid>
		</DashboardLayout>
	);
}

export default Duplicate;
